import PageDetail from './Detail';

export default PageDetail;
